<template>
  <div
    class="modal"
    :class="value ? 'show' : 'hide'"
    :style="
      value ? 'display:block;background-color:#3333337a;' : 'display:none;'
    "
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-scrollable" role="document">
      <div class="modal-content" :style="'width:' + dialogWidth">
        <div class="modal-header">
          <h3 class="">{{ title }}</h3>
        </div>
        <div class="modal-body">
          <p v-html="text"></p>
          <p>{{ sousText ? sousText : "" }}</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary " @click="cancelWin">Annuler</button>
          <button class="btn btn-mouveal" @click="deleteWin">Ok</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mconfirmdialog",
  props: ["value", "title", "text", "sousText", "width"],
  data() {
    return {
      dialog: false,
      dialogWidth: "500px"
    };
  },
  mounted() {},
  watch: {
    value: function(val) {
      this.dialog = val;
      if (this.width) this.dialogWidth = this.width;
    }
  },
  components: {},
  methods: {
    cancelWin() {
      this.$emit("canceled");
    },
    deleteWin() {
      this.$emit("confirmed");
    }
  }
};
</script>
